var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
let BodyModule = class BodyModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.classes = {};
    }
    /**
     * Get current page title
     * @returns string
     */
    get getClasses() {
        return (position) => {
            if (typeof position !== "undefined") {
                return this.classes[position];
            }
            return this.classes;
        };
    }
    [_a = Mutations.SET_CLASSNAME_BY_POSITION](payload) {
        const { position, className } = payload;
        if (!this.classes[position]) {
            this.classes[position] = [];
        }
        this.classes[position].push(className);
    }
    [_b = Actions.ADD_BODY_CLASSNAME](className) {
        document.body.classList.add(className);
    }
    [_c = Actions.REMOVE_BODY_CLASSNAME](className) {
        document.body.classList.remove(className);
    }
    [_d = Actions.ADD_BODY_ATTRIBUTE](payload) {
        const { qulifiedName, value } = payload;
        document.body.setAttribute(qulifiedName, value);
    }
    [_e = Actions.REMOVE_BODY_ATTRIBUTE](payload) {
        const { qulifiedName } = payload;
        document.body.removeAttribute(qulifiedName);
    }
    [_f = Actions.ADD_CLASSNAME](payload) {
        this.context.commit(Mutations.SET_CLASSNAME_BY_POSITION, payload);
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _f, null);
BodyModule = __decorate([
    Module
], BodyModule);
export default BodyModule;
//# sourceMappingURL=BodyModule.js.map